
import Vue from "vue";
import CountyAvailabilityTable from "@/components/Quotes/CountyAvailabilityTable.vue";

export default Vue.extend({
  name: "CountyAvailabilityDropdown",
  components: { CountyAvailabilityTable },
  props: {
    data: { type: Object, required: true },
    showAction: { type: Boolean, default: false }
  },
  data() {
    return {
      activeName: "1" // auto-expand the first pane
    };
  },
  methods: {
    formatCountyAvailabilityData(isAvailable: boolean = false) {
      return isAvailable ? this?.data?.allowed : this?.data?.blocked;
    },
    handleCreateQuote(data: Record<string, any>) {
      this.$emit("create-quote", data);
    }
  }
});
